import * as types from './mutation-types';

export default {
    [types.SET_ERROR](state, error) {
        state.status = error.status;
        state.statusText = error.statusText;
        state.options = error.options;
    },
    [types.SET_ERROR_STATUS](state, status) {
        state.status = status;
    },
    [types.SET_ERROR_STATUS_TEXT](state, statusText) {
        state.statusText = statusText;
    },
    [types.SET_ERROR_OPTIONS](state, options) {
        state.options = options;
    },
};